import axiosInstance from './axiosInstance';

// ==================== Types ====================

export interface UnpostedItemDto {
  id: number;
  documentNumber: string;
  documentDate: string;
  description: string;
  descriptionAr: string;
  totalDebit: number;
  totalCredit: number;
  amount: number;
  status: string;
  createdDate: string;
  sourceType?: string;
  voucherType?: string;
  payeeName?: string;
  paymentMethod?: string;
  branchName?: string;
  branchNameAr?: string;
  supplierName?: string;
  warehouseName?: string;
  warehouseNameAr?: string;
}

export interface UnpostedSectionDto {
  sectionType: string;
  sectionTitle: string;
  sectionTitleAr: string;
  iconName: string;
  unpostedCount: number;
  totalAmount: number;
  items: UnpostedItemDto[];
}

export interface BatchPostingPageDto {
  totalUnpostedCount: number;
  sections: UnpostedSectionDto[];
}

export interface BatchPostRequestDto {
  sectionType: string;
  ids: number[];
}

export interface BatchPostItemResultDto {
  id: number;
  documentNumber?: string;
  isSuccess: boolean;
  message: string;
}

export interface BatchPostResultDto {
  sectionType: string;
  totalRequested: number;
  successCount: number;
  failedCount: number;
  results: BatchPostItemResultDto[];
}

// ==================== API Calls ====================

const BASE_URL = '/BatchPosting';

/** جلب جميع العناصر الغير مرحلة لكل السكاشن */
export const getAllUnposted = async (): Promise<BatchPostingPageDto> => {
  const response = await axiosInstance.get(BASE_URL);
  return response.data;
};

/** جلب جميع العناصر المرحلة لكل السكاشن */
export const getAllPosted = async (): Promise<BatchPostingPageDto> => {
  const response = await axiosInstance.get(`${BASE_URL}/posted`);
  return response.data;
};

/** جلب العناصر الغير مرحلة لسكشن محدد */
export const getUnpostedBySection = async (sectionType: string): Promise<UnpostedSectionDto> => {
  const response = await axiosInstance.get(`${BASE_URL}/section/${sectionType}`);
  return response.data;
};

/** ترحيل جماعي */
export const batchPost = async (request: BatchPostRequestDto): Promise<BatchPostResultDto> => {
  const response = await axiosInstance.post(`${BASE_URL}/post`, request);
  return response.data;
};

/** إلغاء ترحيل جماعي */
export const batchUnpost = async (request: BatchPostRequestDto): Promise<BatchPostResultDto> => {
  const response = await axiosInstance.post(`${BASE_URL}/unpost`, request);
  return response.data;
};